<template>
  <svg
    class="svg-blob-one"
    width="600"
    height="600"
    viewBox="0 0 600 600"
    xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(300,300)">
      <path d="M123.8,-153.4C143,-156.5,129,-96.9,142.2,-48.2C155.3,0.6,195.6,38.6,196.1,72C196.6,105.3,157.4,134,118.1,134.5C78.8,135.1,39.4,107.5,4.8,100.9C-29.8,94.3,-59.6,108.6,-91.1,105.6C-122.6,102.5,-156,82,-168.2,52.7C-180.4,23.4,-171.5,-14.7,-144.4,-31C-117.2,-47.4,-71.8,-41.9,-44.7,-36.2C-17.6,-30.6,-8.8,-24.8,21.7,-54.7C52.3,-84.7,104.6,-150.3,123.8,-153.4Z" fill="#F1F1F1" />
    </g>
  </svg>
</template>

<script>
export default {
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style scoped>
  .svg-blob-one {
    position: absolute;
    z-index: -1;
    transform: scale(3.1);
    left: 665px;
    margin-top: -50px;
    pointer-events: none;
  }

  @media only screen and (max-width: 450px) {
    .svg-blob-one {
      transform: scale(6.1);
      left: 41px;
      margin-top: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// blob.vue?0900e17b